import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _SIZE_TO_CLASSNAME;
import s from './icon.module.scss';
export var SIZES = {
  XXS: 'XXS',
  XS: 'XS',
  S: 'S',
  MD_S: 'MD_S',
  // Medium Small: size: 1.4rem
  MD: 'MD',
  L: 'L',
  XL: 'XL',
  XXL: 'XXL',
  XXXL: 'XXXL'
};
export var SIZE_TO_CLASSNAME = (_SIZE_TO_CLASSNAME = {}, _defineProperty(_SIZE_TO_CLASSNAME, SIZES.XXS, s.size__xxs), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.XS, s.size__xs), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.S, s.size__s), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.MD_S, s.size__mds), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.MD, s.size__md), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.L, s.size__l), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.XL, s.size__xl), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.XXL, s.size__xxl), _defineProperty(_SIZE_TO_CLASSNAME, SIZES.XXXL, s.size__xxxl), _SIZE_TO_CLASSNAME);